/**
 * Helper utility to inject a dynamic external JavaScript tag into the document head
 */
const injectExternalScript = (url, id = "") => {
  if (id && document.getElementById(id)) return;

  const script = document.createElement("script");
  script.src = url;
  script.async = true;
  if (id) script.id = id;

  document.head.appendChild(script);
};

export const initializeTrackingScripts = () => {
  const currentUrlParams = window.location.search;

  const isGoogleDebuggerActive =
    currentUrlParams.includes("gtm_debug=") ||
    currentUrlParams.includes("gtm_preview=") ||
    currentUrlParams.includes("gtm_auth=") ||
    currentUrlParams.includes("tagassistant.google.com");

  const rawPrefs = localStorage.getItem("cookiePreferences");

  if (!rawPrefs && !isGoogleDebuggerActive) return;

  const prefs = rawPrefs
    ? JSON.parse(rawPrefs)
    : { analytics: true, marketing: true, functional: true };

  const GA_MEASUREMENT_ID = "G-SMC18PQMH7";

  if (prefs.analytics) {
    if (!window.gtag) {
      injectExternalScript(
        `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`,
        "google-analytics-script"
      );

      window.dataLayer = window.dataLayer || [];

      window.gtag = function () {
        window.dataLayer.push(arguments);
      };

      window.gtag("js", new Date());

      window.gtag("config", GA_MEASUREMENT_ID, {
        anonymize_ip: true,
      });
    }
  } else {
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
  }

  // ========================================================================== //
  // 2. 🎯 MARKETING COOKIES BLOCK (Meta / Facebook Pixel Implementation)      //
  // ========================================================================== //
  const FB_PIXEL_ID = "1561901705317471"; // ⚠️ REPLACE WITH YOUR REAL PIXEL ID

  if (prefs.marketing) {
    if (!window.fbq) {
      console.log(
        "🎯 Marketing Cookies Accepted: Activating Retargeting Pixels..."
      );

      // Standard tracking arrays constructor injection logic from Meta
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://facebook.net");

      // Initialize the pixel instance context configuration tracking lines
      window.fbq("init", FB_PIXEL_ID);
      window.fbq("track", "PageView"); // Fire default view events
    }
  } else {
    // Clean out or drop pixel references if they are explicitly turned off
    if (window.fbq) {
      window.fbq = undefined;
      console.log(
        "🔒 Marketing Declined: Meta Pixel instance removed from application scope."
      );
    }
  }

  // ========================================================================== //
  // 3. ⚙️ FUNCTIONAL COOKIES BLOCK (Support Widgets / Custom Layouts Memory)    //
  // ========================================================================== //
  if (prefs.functional) {
    console.log("⚙️ Functional Cookies Accepted: Booting custom widgets...");

    // Example: Dynamically inject a Customer Live-Chat or Help Center widget
    // injectExternalScript("https://livechatinc.com", "live-chat-script");
  } else {
    // Remove injected elements if they exist and the user opts out
    const functionalScript = document.getElementById("live-chat-script");
    if (functionalScript) {
      functionalScript.remove();
      console.log(
        "🔒 Functional Declined: Support widgets tags purged successfully."
      );
    }
  }
};
